import script from "./SelectCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCard.vue?vue&type=script&setup=true&lang=js"

import "./SelectCard.vue?vue&type=style&index=0&id=94a00292&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94a00292"]])

export default __exports__